import { range } from 'd3-array';
import { radialLine, curveCardinalClosed as curve } from "d3-shape";

export const areas = ["destra", "centro-destra", "m5s", "centro-sinistra", "sinistra"];
export const wordArticles = {
  'destra': 'la',
  'centro-destra': 'il',
  'm5s': 'il',
  'centro-sinistra': 'il',
  'sinistra': 'la',
}
export const prettyNames = {
  'destra': 'Destra',
  'centro-destra': 'Centro Destra',
  'm5s': 'Movimento 5 Stelle',
  'centro-sinistra': 'Centro Sinistra',
  'sinistra': 'Sinistra',
  'lega': 'Lega',
  }
export const colors = {
  destra: "#244761",
  "centro-destra": "#56CCF2",
  "centro-sinistra": "#F55B5B",
  sinistra: "rgba(186,0,78,1)",
  m5s: "#FFDC73",
  black: "rgba(0,0,0,0)",
  lega: "#377D22",
};

const sentencesToBeCleanedUp = [
  ' - Il Fatto Quotidiano',
  ' - Il Post',
  ' \\| VIDEO',
  ' - Secolo d\'Italia',
  ' \\| Sky TG24',
  ' \\| LaPresse',
  ' - La Nazione',
  ' \\(FOTO, DOCUMENTO\\)',
  ' - QuotidianoNet',
  ' / Guarda',
  ' / Video-cult',
  'FOTO',
  'DIRETTA',
  ' - IlGiornale.it'
];
export const cleanUp = (sentence) => {
  let cleanSentence = sentence;
  sentencesToBeCleanedUp.forEach(cleanUpString => {
    const re = new RegExp(cleanUpString,'g');
    cleanSentence = cleanSentence.replace(re,'');
  })
  return cleanSentence;
}


const arc = (sides = 4) => (2 * Math.PI / sides);
export const SQRT2 = Math.sqrt(2);
export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;

export const radialArea = radialLine().curve(curve.tension(0.95));

export const getCoords = (side, sides = 4, margin = 0) => {
  const r = (side - margin) * SQRT2;
  const points = range(sides).map(function(d) {
    return [d * arc(sides), r / 2];
  });
  return points;
}

export const getConnectingLine = (x1, y1, x2, y2) => {
  const l = x1 - x2;
  const h = y1 - y2;

  const d = Math.sqrt(l * l + h * h);
  const rad = Math.atan2(h, l);
  const deg = rad * RAD2DEG;
  const offset = {
    y: y1,
    x: x1
  };

  return {
    top: `${offset.y}px`,
    left: `${offset.x}px`,
    width: `${d}px`,
    transform: `rotate(${deg - 180}deg)`
  };
};



// WEBPACK FOOTER //
// ./src/elezioni/utils.js